/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { reducerHandlerFromState } from "@monsma/XDL/Utilities/reducerHandlerFromState";

const ReducerName = "xCheckout";

const initialState = {
    deliveryMessaging: "",
    ltlDeliveryType: "",
    appointmentRequired: "",
    liftGateRequired: "",

    customerReference1: "",

    paymentProfile: "",
    po: "",
    paymentMethodX: "",

    cardHolder: "",
    lastFour: "",
    expDate: "",
    ccType: "",
};

// auto generate reducers and handlers based on the initial state
const { xReducers, xHandlers } = reducerHandlerFromState(initialState, ReducerName);

// create and inject reducer into redux
const xTypedReducer = createTypedReducerWithImmer(initialState, xReducers);
(reducers as any)[ReducerName] = xTypedReducer;

// generate generic action types based on initial state and typed reducer
type xActionsType = { [key in keyof typeof initialState]: typeof xTypedReducer };

// the export should include your reducer name
// by default you will have handlers ready with variable name for something as setSomething
// also you can still call them reducer manually with ReducerName/setSomething
export const xCheckoutHandlers = xHandlers;
export type xCheckoutState = { [ReducerName]: typeof initialState };
export type xCheckoutActions = Parameters<xActionsType[keyof xActionsType]>[1] | AnyAction;
